import axios from "axios";

/* =========================
   CONFIG
   ========================= */
export const portalUrl = '';

/* =========================
   LIFERAY AUTH HEADERS
   ========================= */
const liferayHeaders = {
  "X-CSRF-Token": window.Liferay?.authToken,
  "Content-Type": "application/json",
  Accept: "application/json",
};

/* =========================
   AUTHENTICATED FETCH
   ========================= */
async function authFetch(relativeUrl) {
  const response = await fetch(`${portalUrl}${relativeUrl}`, {
    method: "GET",
    credentials: "include",
    headers: liferayHeaders,
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error("Liferay API Error:", response.status, errorText);
    throw new Error(`API failed: ${response.status}`);
  }

  return response.json();
}

/* =========================
   GET DISTINCT CITIES (hardcoded)
   ========================= */
export const getHousingProjects = async () => {
  const cities = [
  "AGRA","AHMEDABAD","AHMEDNAGAR","AJMER","ALAPPUZHA","ALIGARH",
  "AMBARNATH","AMBERNATH","AMRAVATI","AMRITSAR","ANANTAPUR","ANEKAL",
  "ANGUL","ANKLESHWAR","ASANSOL","AURANGABAD","BADLAPUR","BAGALKOT",
  "BAGHPAT","BAHADUR GARH","BAHADURGARH","BALANGIR","BALASORE","BALLARI",
  "BANKURA","BARDHAMAN","BAREILLY","BARGARH","BARMER","BATHINDA",
  "BEHRAMPUR","BELAGAVI","BELAPUR","BENGALURU","BERHAMPUR","BHADRAK",
  "BHADRAVATHI","BHAGALPUR","BHATINDA","BHIMAVARAM","BHIWANDI","BHOPAL",
  "BHUBANESWAR","BIKANER","BILASPUR","BOLPUR","BURDWAN","CHANDANNAGAR",
  "CHANDIGARH","CHENNAI","CHHATRAPATI SAMBHAJINAGAR","CHIKODI","COIMBATORE",
  "CUTTACK","DADRA AND NAGAR HAVELI","DAVANAGERE","DEHRADUN","DELHI NCR",
  "DEOGHAR","DEVANAHALLI","DHANBAD","DHARMAPURI","DHARWAD","DIBRUGARH",
  "DURG","DURGAPUR","ERNAKULAM","ERNAKULM","ERODE","FARIDABAD","FIROZABAD",
  "GANDHINAGAR","GANNAVARAM","GAUTAM BUDDHA NAGAR","GAYA","GHAZIABAD","GOA",
  "GORAKHPUR","GREATER NOIDA","GUNTUR","GURUGRAM","GUWAHATI","GUWHATI",
  "GWALIOR","HAJIPUR","HALDWANI","HANAMKONDA","HANSI","HARIDWAR","HARYANA",
  "HATHRAS","HAVERI","HAZARIBAGH","HISAR","HOOGHLY","HOSAPETE","HOSUR",
  "HOWRAH","HUBBALLI","HUZURNAGAR","HYDERABAD","INDORE","JABALPUR",
  "JAGDALPUR","JAIPUR","JALANDHAR","JAMSHEDPUR","JHANSI","JIND","JODHPUR",
  "JORHAT","JUNAGADH","KADDAPA","KAIKALUR","KAKINADA","KALABURAGI",
  "KALAHANDI","KALYAN","KANNUR","KANPUR","KARIMNAGAR","KARKALA","KARNAL",
  "KARWAR","KASHIPUR","KATIHAR","KENDRAPARA","KHAMMAM","KHARAR","KHARGHAR",
  "KOLAR","KOLHAPUR","KOLKATA","KOLLAM","KOTA","KOTTAYAM","KOVILPATTI",
  "KOZHIKODE","KUKATPALLY","KULLU","KUMBAKONAM","KUMTA","KUNDAPUR","KURNOOL",
  "LUCKNOW","LUDHIANA","MADIKERI","MADURAI","MAHESANA","MALAPPURAM","MALDA",
  "MANASA","MANAWAR","MANDYA","MANGALURU","MANIPAL","MANSA","MATHURA",
  "MEERUT","MOHALI","MORADABAD","MUMBAI","MUMBRA","MURSHIDABAD",
  "MUZAFFARNAGAR","MUZAFFARPUR","MYSURU","NAGAON","NAGERKOVIL","NAGPUR",
  "NALANDA","NALGONDA","NANDED","NARSINGHGPUR","NASHIK","NAVI MUMBAI",
  "NELLORE","NIRMAL","NIZAMABAD","NOIDA","ONGOLE","PALAKHAD","PALAKKAD",
  "PALGHAR","PALI","PALUS","PALWANCHA","PANCHKULA","PANDHARPUR","PANIPAT",
  "PATIALA","PATNA","PONDICHERRY","PRAYAGRAJ","PUNE","PURI","PURNIA",
  "PURULIA","PUTTUR","RAICHUR","RAIGAD","RAIGARH","RAIPUR","RAJAHMUNDRY",
  "RAJAMPET","RAJANAGARAM","RAJKOT","RANCHI","RANGAREDDY","RANIGANJ",
  "RATNAGIRI","RAVULAPALEM","REWARI","ROHTAK","ROORKEE","ROURKELA",
  "RUDRAPUR","SAGAR","SALEM","SAMBALPUR","SANAGAREDDY","SANGLI","SANGRUR",
  "SARAN","SAS NAGAR","SECUNDERABAD","SHAHAPUR","SHAIKPET","SHIMLA",
  "SHIVAMOGGA","SHIVPURI","SHRIRAMPUR","SIKAR","SILCHAR","SILIGURI","SION",
  "SIRSI","SOLAN","SOLAPUR","SONIPAT","SOUTH  PARGANAS","SRIGANGANAGAR",
  "SRIKAKULAM","SURAT","SURYAPET","TADEPALLI","TAMILNADU","TANUKU","TEZPUR",
  "THANE","THANJAVUR","THIRUNELVELI","THIRUVANANTHAPURAM","THRISSUR",
  "TIRUCHIRAPALLI","TIRUPATHI","TIRUPATI","TRICHY","TRIVANDRUM","TUMAKURU",
  "TUMKUR","UDAIPUR","UDUPI","UJJAIN","ULHASNAGAR","UMBERGAON","VADODARA",
  "VARANASI","VIJAYAPURA","VIJAYAWADA","VISAKHAPATNAM","VISHAKAPATNAM",
  "VIZIANAGARAM","VIZIANAGRAM","WARANGAL","WARDHA","WEST GODAVARI",
  "YAMUNA NAGAR","ZIRAKPUR"
];
  return cities.sort((a, b) => a.localeCompare(b));
};

/* =========================
   GET PROJECTS BY CITY
   ========================= */
export async function getHousingProjectsByCity(city) {
  const data = await authFetch(
    `/o/c/housingprojects/?fields=projectName&filter=city eq '${city}'&pageSize=-1`
  );
  const items = Array.isArray(data.items) ? data.items : [];
  return [...new Set(items.map(x => x.projectName).filter(Boolean).map(x => x.trim()))];
}

/* =========================
   GET BUILDERS BY PROJECT
   ========================= */
export async function getBuilderName(projectName) {
  const data = await authFetch(
    `/o/c/housingprojects/?fields=builderName&filter=projectName eq '${projectName}'&pageSize=-1`
  );
  const items = Array.isArray(data.items) ? data.items : [];
  return [...new Set(items.map(x => x.builderName).filter(Boolean).map(x => x.trim()))];
}

/* =========================
   GET FULL ROWS
   ========================= */
export async function getRowsByCityProjectBuilder(city, projectName, builderName) {
  const filterQuery =
    `city eq '${city}' and projectName eq '${projectName}' and builderName eq '${builderName}'`;
  const data = await authFetch(
    `/o/c/housingprojects/?filter=${encodeURIComponent(filterQuery)}&pageSize=-1`
  );
  return Array.isArray(data.items) ? data.items : [];
}